import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { CompleteRegistration } from '@/components/auth';

const completeRegistrationSearchSchema = z.object({
  token: z.string().optional(),
  campaignId: z.string().optional(),
});

export const Route = createFileRoute('/complete-registration')({
  validateSearch: completeRegistrationSearchSchema,
  beforeLoad: ({ context }) => {
    // Redirect authenticated users away from complete registration
    if (context.auth.user) {
      throw redirect({ to: '/' });
    }
  },
  component: CompleteRegistration,
});
